export function get_options() {
  return [
    {
      value: "工程造价咨询业务",
      label: "工程造价咨询业务",
      children: [
        {
          value: "按专业",
          label: "按专业",
          children: [
            { value: "房屋建造工程", label: "房屋建造工程" },
            { value: "市政工程", label: "市政工程" },
            { value: "公路工程", label: "公路工程" },
            { value: "铁路工程", label: "铁路工程" },
            { value: "城市轨道交通工程", label: "城市轨道交通工程" },
            { value: "航空工程", label: "航空工程" },
            { value: "航天工程", label: "航天工程" },
            { value: "火电工程", label: "火电工程" },
            { value: "水电工程", label: "水电工程" },
            { value: "核工业工程", label: "核工业工程" },
            { value: "新能源工程", label: "新能源工程" },
            { value: "水利工程", label: "水利工程" },
            { value: "水运工程", label: "水运工程" },
            { value: "矿山工程", label: "矿山工程" },
            { value: "冶金工程", label: "冶金工程" },
            { value: "石油天然气工程", label: "石油天然气工程" },
            { value: "石化工程", label: "石化工程" },
            { value: "化工、医药工程", label: "化工、医药工程" },
            { value: "农业工程", label: "农业工程" },
            { value: "林业工程", label: "林业工程" },
          ],
        },
        {
          value: "按业务范围",
          label: "按业务范围",
          children: [
            { value: "前期决策阶段咨询", label: "前期决策阶段咨询" },
            { value: "实施阶段咨询", label: "实施阶段咨询" },
            { value: "结（决）算阶段咨询", label: "结（决）算阶段咨询" },
            { value: "全过程工程造价咨询", label: "全过程工程造价咨询" },
            {
              value: "工程造价经济纠纷的鉴定和仲裁咨询",
              label: "工程造价经济纠纷的鉴定和仲裁咨询",
            },
            { value: "其他", label: "其他" },
          ],
        },
      ],
    },
    {
      value: "其他业务",
      label: "其他业务",
      children: [
        { value: "招标代理业务", label: "招标代理业务" },
        { value: "项目管理业务", label: "项目管理业务" },
        { value: "工程咨询业务", label: "工程咨询业务" },
        { value: "建设工程监理业务", label: "建设工程监理业务" },
      ],
    },
    {
      value: "其他",
      label: "其他",
      children: [
        { value: "勘察设计业务", label: "勘察设计业务" },
        { value: "会计审核业务", label: "会计审核业务" },
        { value: "银行金融业务", label: "银行金融业务" },
        { value: "其他的业务", label: "其他的业务" },
      ],
    },
  ];
}
